/**
 * Referral FAQ Block Component
 * 
 * Simple FAQ explaining how referrals work.
 */

import { useTranslation } from 'react-i18next'
import { HelpCircle, Share2, Gift, Sparkles } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'

export function ReferralFAQBlock() {
  const { t } = useTranslation('common')

  const faqItems = [
    {
      icon: Share2,
      text: t('referrals.faq1', 'Share your unique referral link with friends.'),
    },
    {
      icon: Gift,
      text: t('referrals.faq2', 'When they sign up and start reading, you both unlock rewards.'),
    },
    {
      icon: Sparkles,
      text: t('referrals.faq3', 'Unlocked rewards appear here and in your rewards panel.'),
    },
  ]

  return (
    <Card className="faq-block bg-muted/30">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <HelpCircle className="h-4 w-4 text-muted-foreground" />
          {t('referrals.howItWorks', 'How it works')}
        </CardTitle>
      </CardHeader>
      
      <CardContent>
        <ul className="faq-list space-y-3">
          {faqItems.map((item, index) => (
            <li key={index} className="faq-item flex items-start gap-3">
              <div className="icon-wrapper p-1.5 rounded-full bg-primary/10 mt-0.5">
                <item.icon className="h-3.5 w-3.5 text-primary" />
              </div>
              <span className="text-sm text-muted-foreground">{item.text}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  )
}

